import { Popover } from "antd";
import BaseListPage from "../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
} from "../../usecases/object";
import withRouter from "../../withRouter";
import NotificationPresenter from "./NotificationPresenter";
import NotificationContents from "./components/NotificationContents";

class Notification extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new NotificationPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
    );
  }

  getCollectionName() {
    return "notifications";
  }

  render() {
    const { objects, loading, count, limit, current, newNotification } =
      this.state;

    return (
      <div className="tooltip-container">
        <Popover
          content={<NotificationContents objects={objects} />}
          trigger="click"
        >
          <button
            style={{
              border: "0",
              backgroundColor: "white",
              position: "relative",
            }}
          >
            <i style={{ zoom: "1.3" }} className="bi bi-bell" />
            {objects?.filter((obj) => !obj.isRead).length > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: "-6px",
                  right: "-6px",
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "50%",
                  padding: ".2rem",
                  fontSize: "10px",
                  height: "1.2rem",
                  width: "1.2rem",
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                {objects.filter((obj) => !obj.isRead).length}
              </span>
            )}
          </button>
        </Popover>
        <div className="tooltip-content">Notifications</div>
      </div>
    );
  }
}
export default withRouter(Notification);
